import { convertStyleObjectToCss as e } from "../../utils/style-helpers.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as t } from "./constants.mjs";
import { getParagraphStyles as n } from "./utils.mjs";
import { CustomParagraphNodeView as r } from "./custom-paragraph-node-view.mjs";
import { useParagraphSpaceExtensionToolbar as i } from "./use-paragraph-space-extension.mjs";
import { ReactNodeViewRenderer as a, mergeAttributes as o } from "@tiptap/react";
import { Paragraph as s } from "@tiptap/extension-paragraph";
//#region src/extensions/paragraph-extension/index.ts
var c = (e) => e !== "0" && e !== "0px" && e !== "0rem" && e !== "0em" && e !== 0 && e !== "" && e != null && e !== " ", l = (e) => e === "" || e == null || e === " ", u = s.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			[t]: {
				default: !1,
				parseHTML: (e) => {
					if (!e.style) return !1;
					if (l(e.style.marginTop) && l(e.style.marginBottom)) return !0;
					let t = c(e.style.marginTop), n = c(e.style.marginBottom);
					return t && n;
				}
			}
		};
	},
	addNodeView() {
		return a(r);
	},
	renderHTML({ HTMLAttributes: r, node: i }) {
		let a = i.attrs[t];
		return [
			"p",
			o({
				dir: "auto",
				style: e(n(a))
			}, r),
			0
		];
	}
});
//#endregion
export { u as ParagraphExtension, i as useParagraphSpaceExtensionToolbar };
